import items from './items';
import slots from './slots';

export default {
  items,
  slots,
};



// WEBPACK FOOTER //
// ./src/app/services/appointment/index.js